import { render } from "./edit.vue?vue&type=template&id=649fa7f3"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/apartment/setup/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "649fa7f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('649fa7f3', __exports__)) {
    console.log('reload')
    api.reload('649fa7f3', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=649fa7f3", () => {
    console.log('re-render')
    api.rerender('649fa7f3', render)
  })

}


export default __exports__